import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import '../../styles/LineChart.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChart = (props) => {
    // Extract data from props
    const { apiData } = props;

    // Check if the apiData is available before rendering the chart
    if (!apiData) {
        return <div>Loading...</div>; // Optionally, show a loading message until the data is ready
    }

    // Get dynamic data from the props
    const totalEnquiries = apiData.total_enquiries || 0;
    const totalRegisteredStudents = apiData.total_registered_students || 0;
    const totalEnrolledStudents = apiData.total_enrolled_students || 0;

    // Data for the Line Chart
    const data = {
        labels: ['Enquiries', 'Registered Students', 'Enrolled Students'], // X-axis labels
        datasets: [
            {
                label: 'Student Data',
                data: [totalEnquiries, totalRegisteredStudents, totalEnrolledStudents], // Dynamic data
                borderColor: '#b08ea2', // Line color
                backgroundColor: '#b08ea2', // Line fill color
                fill: true, // Fill the area under the line
                tension: 0.4, // Smoothness of the curve
                pointRadius: 6, // Radius of the points
                pointBackgroundColor: '#b08ea2', // Point color
                pointHoverRadius: 10, // Hover effect for points
            },
        ],
    };

    // Options for the Line Chart
    const options = {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`; // Display the exact value on hover
                    },
                },
            },
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
            title: {
                display: true,
                text: 'Student Data Overview',
                font: {
                    size: 18,
                    weight: 'bold',
                    family: 'Arial, sans-serif',
                },
                color: '#2C3E50',
            },
        },
        scales: {
            y: {
                beginAtZero: true, // Start Y-axis at 0
                grid: {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                },
            },
            x: {
                grid: {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                },
            },
        },
    };

    return (
        <Line data={data} options={options} />
    );
};

export default LineChart;
